import { set, toggle } from '@/utils/vuex';
import defaultState from "./state";
import Vue from 'vue';

export default {
  resetState: state => state = Object.assign({}, defaultState),
  setList (state, response) {
    state.count = response.count
    if (!state.list) state.list = []
    state.list = response.data.filter(m => ['delivered','definitive','onhold','reserved','offered'].indexOf(m.rating) > -1 || m.event_date || (m.questions && m.questions.length>0) || m.track).sort(compare2)//state.list.concat(response.data)
  },
  setSuppliers (state, response) {
      state.suppliers = response.data.filter(m => ['delivered','definitive','onhold','reserved','offered'].indexOf(m.rating) > -1 || m.event_date || (m.questions && m.questions.length>0) || m.track).sort(compare2)//state.list.concat(response.data)
  },
  addListItem(state, item) {
    state.list.push(item)
  },
  setMatch (state, match) {
    state.match = Object.assign(match)
  },
  setSelected (state, selected) {
    if (!selected) selected = state.selected
    state.selected = Object.assign({}, selected)
    if (!state.selected.questions) state.selected.questions = []
     if (!state.selected.answers) state.selected.answers = []
     //state.suppliers = []
     state.taglist = []
     state.selected.answers = state.selected.answers.filter(a => state.selected.questions.filter(q => q.title == a.question).length > 0) //clean
  },
  setTemplates (state, list) {
    state.templates = list
  },
  setSearch (state, search) {
    state.search = search
  },
  setTags (state, tags) {
    tags.sort((a, b) => (a.tag > b.tag) ? 1 : -1)
    state.taglist = tags
  },
  setQuestion (state, question) {
    state.question = question
  },
  saveSelected (state, modified) {
    state.modified = (modified == true)
    state.selected.modified = (modified == true)
  },
  updateQuestions (state, question) {
    state.selected.questions = question
  },
  updateSelected (state, sel) {
    var q = state.selected
    if (q._id != sel._id) q = state.list.filter(item => item._id == sel._id )[0]
    //q.questions = q.questions
    //q.answers = q.answers
  },
  addDescription(state, update){
    state.selected = Object.assign(state.selected , update)
    return true
  },
  addQuestion(state, question) {
    if (!state.selected.questions) state.selected.questions = []
    if (state.selected.questions.filter(item => item.title == question.title ).length > 0) return false
    state.selected.questions.push(question)
    state.selected.questions = state.selected.questions.sort(compare)
  },
  addQuestiona(state, question) {
    if (!state.selected.questions) state.selected.questions = []
    if (state.selected.questions.filter(item => item.title == question.title ).length > 0) return false
    state.selected.questions.push(question)
    
    state.selected = Object.assign({}, state.selected)
        return true
  },
  sortQuestions(state){
    state.selected.questions = state.selected.questions.sort(compare)
  },
  removeQuestion(state, index) {
    var question = state.selected.questions.splice(index, 1)
    
    state.selected.answers = state.selected.answers.filter(q => q.question != question.title)
    state.modified = true
    return question
  },
  deleteQuestion(state, question) {
    state.selected.questions = state.selected.questions.filter(q => q.title != question.title)
    state.selected.answers = state.selected.answers.filter(a => a.question != question.title)
    state.modified = true
    return question
  },
  cleanAnswers(state){
    state.selected.answers = state.selected.answers.filter(a => state.selected.questions.filter(q => q.title == a.question).length > 0)
  },
  deleteAnswer(state, answer) {
    answer.deleted = true
    state.selected.answers = [...state.selected.answers.filter(a => !a.deleted)]
    state.modified = true
  },
  updateAnswer (state, answer) {
    state.modified = true
  },
  setModified (state,modified){
    state.modified = modified
  },
  addAnswer(state, answer) {
    if (!state.selected.answers) state.selected.answers = []
    if (answer.options && answer.options.length>0 && answer.options[0] && answer.options[0] == 'JA' && answer.tag) state.selected.tags.push({tag: answer.tag})
    if (answer.options && answer.options.length>0 && answer.options[0] && answer.options[0] == 'NEE' && answer.notag) state.selected.tags.push({tag: answer.notag})
    state.selected.answers.push(answer)
    
    //state.modified = true
  },
  resetQuestions(state) {
    state.selected.questions = []
    state.selected.answers = []
    state.modified = true
  },
  reset(state) {
    state.selected.questions = []
    state.selected.answers = []
     state.suppliers = []
    state.modified = true
  }
};
function compare( a, b ) {
      var scoreA = a.optional ? 0 : 1 , 
            scoreB = b.optional ? 0 : 1
      if ( scoreA < scoreB ){
        return 1;
      }
      if ( scoreA > scoreB ){
        return -1;
      }
      return 0;
    }
    
    function compare2( a, b ) {
  var scoreA = a.score || 0 ,scoreB = b.score || 0
  //if (a.answers) scoreA = a.answers.map(item => (item.score+1) * (item.weight || 1)).reduce((prev, next) => prev + next)
  //if (b.answers) scoreB = b.answers.map(item => (item.score+1) * (item.weight || 1)).reduce((prev, next) => prev + next)
  if ( scoreA < scoreB ){
    return 1;
  }
  if ( scoreA > scoreB ){
    return -1;
  }
  return 0;
}